<script setup lang="ts">
  import { ref, defineModel, onMounted, onUnmounted, computed } from 'vue'

  const file = defineModel('file', {
    type: File,
    default: null,
  })

  const active = ref(false)
  let inActiveTimeout: number|undefined = undefined
  const events = ['dragenter', 'dragover', 'dragleave', 'drop']

  function onDrop(e) {
    if (e.dataTransfer.files.length > 1) {
      alert('You can only upload one file at a time')
      return
    }

    setInactive()
    file.value = e.dataTransfer.files[0]
  }

  function onInputChange(e) {
    if (e.target.files.length > 1) {
      alert('You can only upload one file at a time')
      return
    }

    file.value = e.target.files[0]
  }

  function preventDefaults(e) {
    e.preventDefault()
  }

  function setActive() {
    active.value = true
    clearTimeout(inActiveTimeout)
  }

  function setInactive() {
    inActiveTimeout = setTimeout(() => {
      active.value = false
    }, 100)
  }

  const imgSrc = computed(() => {
    return file.value ? URL.createObjectURL(file.value) : ''
  })

  onMounted(() => {
    events.forEach((eventName) => {
      document.body.addEventListener(eventName, preventDefaults)
    })
  })

  onUnmounted(() => {
    events.forEach((eventName) => {
      document.body.removeEventListener(eventName, preventDefaults)
    })
  })
</script>

<template>
  <div class="relative" :data-active="active" @dragenter.prevent="setActive" @dragover.prevent="setActive" @dragleave.prevent="setInactive" @drop.prevent="onDrop">
    <div class="card w-full bg-base-200">
      <div class="card-body relative">
        <div class="flex flex-col justify-center items-center w-full min-h-[550px]">
          <div class="flex flex-col justify-center items-center" v-if="file === null">
            <svg class="h-10 w-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>upload</title><path d="M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z" /></svg>
            <div class="my-4">Bild hier reinziehen oder Datei auswählen</div>
            <input type="file" class="file-input file-input-bordered" @change.prevent="onInputChange"/>
          </div>
          <div v-else>
            <img :src="imgSrc" class="h-full w-auto" />
            <button class="btn btn-square btn-error absolute top-0 right-0 mt-3 mr-3" @click.prevent="file = null">
              <svg class="w-8 h-8 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Bild entfernen</title><path d="M13 19C13 19.7 13.13 20.37 13.35 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H19C20.11 3 21 3.9 21 5V13.35C20.37 13.13 19.7 13 19 13V5H5V19H13M11.21 15.83L9.25 13.47L6.5 17H13.35C13.75 15.88 14.47 14.91 15.4 14.21L13.96 12.29L11.21 15.83M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z" /></svg>
            </button>
          </div>
          <!-- share state with the scoped slot -->
          <slot :dropZoneActive="active"></slot>
        </div>
      </div>
    </div>
    <div class="absolute top-0 bottom-0 left-0 right-0" v-if="active">
      <div class="card bg-info opacity-50">
        <div class="card-body h-full">
          <div class="min-h-[550px]"></div>
        </div>
      </div>
    </div>
  </div>
</template>
